export const PRODUCT_NAME = "The Science Spotlight";

// HOME PAGE
export const HOME_TITLE = "A Daily Science History Newsletter";

export const HOME_SUBTITLE = "Brought to you by The Daily Atom";

export const HOME_TEXT =
  "Want to learn more about the history of science? The Science Spotlight can help! Our email newsletter is dedicated to sharing science history. Each day, we’ll send you an email about a different scientist or scientific milestone. Whether you’re a science buff or just starting to explore, our daily email newsletter is a great way to expand your understanding of the history of science! Sign up for our free email newsletter today and start learning more about humanity’s incredible scientific achievements.";

export const SUBSCRIBE_BUTTON_TEXT = "Sign Up";

// Articles
export const ARTICLES_TITLE = "Inspiration This Way Comes...";

export const ARTICLES_TEXT =
  "Watch this space, because soon you’ll be able to see all of your favorite literary quotes right here!";

// Subscribe Jump
export const JUMP_TITLE = "Welcome to The Science Spotlight!";

export const JUMP_TEXT_PRIMARY =
  "Please check {EMAIL} for a message from The Science Spotlight to confirm your email.";

export const JUMP_TEXT_SECONDARY =
  "Don't forget to check your junk folder - just in case!";

// Confirm Page
export const CONFIRM_TITLE = "Welcome to The Science Spotlight!";
export const CONFIRM_TEXT = `It’s official – your email address has been confirmed! You should receive your first email newsletter from us tomorrow. Please take a moment to add our email address to your address book so that we don’t end up in your spam folder!`;

// Contact Page

export const CONTACT_TITLE = "Contact Us";
export const CONTACT_TEXT =
  "If you have questions, comments, or suggestions, please let us know! We love hearing from our readers. To get in touch, simply send us an email or reach out to us on social media.  One of our team members will get back to you as soon as possible.";

// About us
export const ABOUT_TITLE = "About The Science Spotlight";

export const ABOUT_BLURB_1_TITLE = "Science History, Delivered Daily";
export const ABOUT_BLURB_1_TEXT =
  "Want to learn more about the history of science but feel overwhelmed? That’s where The Science Spotlight comes in. Each day, we’ll send you a new email covering a groundbreaking scientific invention, a Nobel Prize recipient, or a brief overview about an influential scientist. You’ll learn about all of the amazing innovations and discoveries that humanity has achieved and the people responsible for making them happen! Most of our newsletters focus on scientific breakthroughs from the 19th and 20th centuries (we also cover older achievements from time to time).";

export const ABOUT_BLURB_2_TITLE = "Brought to you by The Daily Atom";
export const ABOUT_BLURB_2_TEXT =
  "The Science Spotlight is brought to you by the same team responsible for The Daily Atom, our popular science fact newsletter that covers facts about animals, space, the Earth, and more. Our small, dedicated team is just as passionate about science history, which is why we created The Science Spotlight! Just like with The Daily Atom, each topic is meticulously researched using reputable sources to bring you only the most accurate information. We cover a wide variety of scientists, inventions, and awards to keep you engaged and ensure that there’s always something new for you to discover in our daily newsletters. Ready to learn something new about the history of science? Sign up for our free email newsletter today!";
